import { render, staticRenderFns } from "./DreamList.vue?vue&type=template&id=04732982&scoped=true&"
import script from "./DreamList.vue?vue&type=script&lang=ts&"
export * from "./DreamList.vue?vue&type=script&lang=ts&"
import style0 from "./DreamList.vue?vue&type=style&index=0&id=04732982&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04732982",
  null
  
)

export default component.exports